import {  } from "helpers/url_helper";

import {
GET_LOKI_JOBS,
GET_LOKI_JOBS_FAILURE,
GET_LOKI_JOBS_SUCCESS,
POST_LOKI_SERVICE_MAPPING,
POST_LOKI_SERVICE_MAPPING_FAILURE,
POST_LOKI_SERVICE_MAPPING_SUCCESS,
} from "./actionTypes";

  export const getLokiJobs = () => ({
    type: GET_LOKI_JOBS,
  });

  export const getLokiJobsSuccess = (data) => ({
    type: GET_LOKI_JOBS_SUCCESS,
    payload: data,
  });

  export const getLokiJobsFail = error => ({
    type: GET_LOKI_JOBS_FAILURE,
    payload: error,
  });

  export const postLokiServiceMapping = (service_mapping) => ({
        type: POST_LOKI_SERVICE_MAPPING,
        payload: { service_mapping }
      });

  export const postLokiServiceMappingFail = error => ({
    type: POST_LOKI_SERVICE_MAPPING_FAILURE,
    payload: error,
  });

  export const postLokiServiceMappingSuccess = loki_jobs => ({
    type: POST_LOKI_SERVICE_MAPPING_SUCCESS,
    payload: loki_jobs,
  });